import { config } from '@/config.ts';

import { ROUTES } from './routes';

type BrandRedirectConfig = Record<string, string>;

/**
 * Map of redirect paths after login for each brand
 */
export const brandLoginRedirectMap: BrandRedirectConfig = {
	default: ROUTES.HOME,
	nomad: ROUTES.HOME,
	ngu3: ROUTES.SHOP,
	com2: ROUTES.SHOP,
	blitz: ROUTES.HOME,
	rockets: ROUTES.HOME,
	rockets_vip: ROUTES.HOME,
	sk2: ROUTES.HOME
};

/**
 * Get redirect path after login for the current brand
 * @returns string - Redirect path for current brand
 */
export const getBrandLoginRedirect = (): string => {
	const brand = config.BRAND || 'default';
	return brandLoginRedirectMap[brand] || brandLoginRedirectMap.default;
};

